import { render, staticRenderFns } from "./BaseInputTextarea.vue?vue&type=template&id=3f27240d&"
import script from "./BaseInputTextarea.vue?vue&type=script&lang=ts&"
export * from "./BaseInputTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports